<template lang="pug">
.v-theme-toggler.theme-toggler(v-if="toggler")
	.theme-toggler__wrap
		.theme-toggler__cell
			button.theme-toggler__button.theme-toggler__button--light(type="button"
					aria-label="'Светлая тема'"
					:class="{'theme-toggler__button--active': theme === 'light'}"
					@click="setLightTheme")
				.theme-toggler__icon.theme-toggler__icon--light
		.theme-toggler__cell
			button.theme-toggler__button.theme-toggler__button--dark(type="button"
					aria-label="'Темная тема'"
					:class="{'theme-toggler__button--active': theme === 'dark'}"
					@click="setDarkTheme")
				.theme-toggler__icon.theme-toggler__icon--dark
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			toggler: null,
			theme: 'light',
			expires: (new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)))
		};
	},

	methods: {
		getCookie(name) {
			let matches = document.cookie.match(new RegExp(
				"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
			));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		setCookie(name, value, options = {}) {
			options = {
				path: '/',
				...options
			};
			if (options.expires instanceof Date) {
				options.expires = options.expires.toUTCString();
			}
			let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
			for (let optionKey in options) {
				updatedCookie += "; " + optionKey;
				let optionValue = options[optionKey];
				if (optionValue !== true) {
					updatedCookie += "=" + optionValue;
				}
			}
			document.cookie = updatedCookie;
		},

		setLightTheme() {
			document.body.classList.remove('dark-theme');
			this.theme = "light";
			this.setCookie('theme', 'light', {expires: this.expires});
		},

		setDarkTheme() {
			document.body.classList.add('dark-theme');
			this.theme = "dark";
			this.setCookie('theme', 'dark', {expires: this.expires});
		},

		dataSet(data) {
			this.toggler = data;
			if (this.getCookie('theme') === 'light') {
				this.setLightTheme();
			} else if (this.getCookie('theme') === 'dark') {
				this.setDarkTheme();
			}
		}
	}
};
</script>